<div class="chart-container">
    <div [id]="chartId" style="display: block; width: 100%;" [ngStyle]="{'height': height + 'px'}"></div>
</div>